'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMessage = buildMessage;
exports.buildPublishedMessage = buildPublishedMessage;
exports.buildUnpublishedMessage = buildUnpublishedMessage;
exports.buildPublishFailedMessage = buildPublishFailedMessage;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _PubNubMessageStatusTypes = require('conversations-schema/constants/PubNubMessageStatusTypes');

var _PubNubMessageStatusTypes2 = _interopRequireDefault(_PubNubMessageStatusTypes);

var _PubNubMessageRecord = require('conversations-schema/records/PubNubMessageRecord');

var _PubNubMessageRecord2 = _interopRequireDefault(_PubNubMessageRecord);

var _propertyValues = require('conversations-schema/lib/propertyValues');

var _timestamps = require('conversations-schema/lib/timestamps');

var _buildMetadataRecord = require('./buildMetadataRecord');

var _buildMetadataRecord2 = _interopRequireDefault(_buildMetadataRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PUBLISHED = _PubNubMessageStatusTypes2.default.PUBLISHED,
    PUBLISH_FAILED = _PubNubMessageStatusTypes2.default.PUBLISH_FAILED,
    UNPUBLISHED = _PubNubMessageStatusTypes2.default.UNPUBLISHED;
function buildMessage() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _pipe2.default)((0, _propertyValues.setDefaultValues)({
    clientTs: (0, _timestamps.generateUniqueClientTimestamp)('PubNubMessageFactory-clientTs'),
    timestamp: (0, _timestamps.generateUniqueClientTimestamp)('PubNubMessageFactory-timestamp')
  }), (0, _propertyValues.enforceValues)({
    metadata: (0, _buildMetadataRecord2.default)(props)
  }), _PubNubMessageRecord2.default)(props);
}

function buildPublishedMessage() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _pipe2.default)((0, _propertyValues.enforceValues)({ status: PUBLISHED }), buildMessage)(props);
}

function buildUnpublishedMessage() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _pipe2.default)((0, _propertyValues.enforceValues)({ status: UNPUBLISHED }), buildMessage)(props);
}

function buildPublishFailedMessage() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _pipe2.default)((0, _propertyValues.enforceValues)({ status: PUBLISH_FAILED }), buildMessage)(props);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/factories/PubNubMessageFactory/index.js
// module id = 22
// module chunks = 0 1